export default {
    change_sim_provider_title: "Change SIM Provider Account",
    change_sim_provider_label: "SIM Provider",
    change_sim_provider_account_label: "SIM Provider Account",
    change_sim_provider_input: "IMEI or Serial",
    change_sim_provider_imei: "IMEI",
    change_sim_provider_serial: "Serial",
    change_sim_provider_model: "Model",
    change_sim_provider_change: "Change",
    change_sim_provider_no_devices_added: "No devices added",
    change_sim_provider_device_is_already_added: "The device is already added",
    change_sim_provider_device_has_not_been_found: "The device has not been found",
    change_sim_provider_this_feature_is_not_available: "This feature is not available",
    change_sim_provider_single_success_message: "The SIM Provider Account of the device has been changed",
    change_sim_provider_multiple_success_message: "The SIM Provider Account of the devices has been updated",
    change_sim_provider_error_message: "Unable to change SIM Provider Account due to an error",
    change_sim_provider_message: "The request to change the SIM Provider Account has been sent successfully, please check the transactions list to see the status of the request.",
}

